/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".header[_ngcontent-%COMP%]{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;margin-left:auto;margin-right:auto}.bigImageContainer[_ngcontent-%COMP%]{position:absolute;right:0;top:60%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.bigImageContainer[_ngcontent-%COMP%]   .bigImage[_ngcontent-%COMP%]{border-radius:16px}@media (max-width:991px){.text-content[_ngcontent-%COMP%]{width:100%}}@media (min-width:992px){.header[_ngcontent-%COMP%]{margin-left:0}}@media (min-width:1200px){.text-content[_ngcontent-%COMP%]{max-width:calc(75% - 80px)}}"];
export { styles as styles };
//# sourceMappingURL=private-class-without-track-banner.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/home/live-class-revamp/private-class-banner/private-class-without-track-banner/private-class-without-track-banner.component.scss.shim.ngstyle.js
// module id = 1533
// module chunks = 27 28 29